import {useCallback,useContext,useState} from 'react';
import {TodayLayoutContext} from './TodayLayoutContext';

// In-memory presentation continuity only. Never persist reports to browser storage.
// The parent discards these snapshots when the authenticated scope changes.
export default function useTodaySnapshot(key, initial) {
 const cache=useContext(TodayLayoutContext)?.snapshots;
 const day=new Date().toLocaleDateString('en-CA');
 const scopedKey=`${day}:${key}`;
 const fallback=()=>typeof initial==='function'?initial():initial;
 const read=()=>{const entry=cache?.get(scopedKey);return entry&&Date.now()-entry.at<300000?entry.value:fallback();};
 const [state,setState]=useState(()=>({key:scopedKey,cache,value:read()}));
 const value=state.key===scopedKey&&state.cache===cache?state.value:read();
 const setValue=useCallback(next=>setState(old=>{
  const previous=old.key===scopedKey&&old.cache===cache?old.value:read();
  const value=typeof next==='function'?next(previous):next;
  cache?.set(scopedKey,{value,at:Date.now()});
  return {key:scopedKey,cache,value};
 // The initial fallback is used only when a scope has no saved value.
 // eslint-disable-next-line react-hooks/exhaustive-deps
 }),[cache,scopedKey]);
 return [value,setValue];
}

export function calendarDay(timeZone='America/New_York') {
 return new Intl.DateTimeFormat('en-CA',{timeZone,year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
}
